import store from '@/store'
import api  from '@/fetch/api'
// const appid = 'wxa5ebc868baac1cba'; //测试账号
const appid = "wx802441402bfff7c2"
function goLogin(next_to) {
  var scope = 'snsapi_userinfo';
  var url = 'http://ccyy.jsltpct.cn'; //正式url
  // var url = 'http://ltxt.tzpdg.top'; //测试url

  var auth_url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + encodeURIComponent(url+next_to) + '&response_type=code&scope=' + scope + '&state=STATE#wechat_redirect';
  window.location.replace(auth_url);
}


function getUser(openid, suc_func)
{
  return new Promise((resolve, reject) => {
    api.getUserInfoByopenid(openid).then(function(resData) {
      var res = JSON.parse(resData);
      console.log("res",res)
      if(res.respCode == 0)
      {
        var UserInfo = res.data;
        if(openid)
        {
          var userId = UserInfo.id?UserInfo.id:"";
          var phone = UserInfo.phone?UserInfo.phone:"";
          var name = UserInfo.name?UserInfo.name:"";
          store.commit('set_mobile',phone);
          store.commit('set_username',name);
          store.commit('set_userid',userId);

          suc_func = suc_func ? suc_func : function() {};
          suc_func();
          resolve({
            phone: phone,
            name: name,
            userId: userId
          });
        } else {
          reject('No openid found');
        }
      } else {
        reject('Error response: ' + res.respCode);
      }
    }).catch(function(err) {
      reject(err);
    });
  });
}

function getUserInfo(code,suc_func)
{
  api.getUserInfo(code).then(function(resData) {
    var res = JSON.parse(resData);
    if(res.respCode == 0)
    {
      var UserInfo = res.data;
      var nickname = UserInfo.nickname?UserInfo.nickname:"";
      var openid = UserInfo.openid?UserInfo.openid:"";
      var userId = UserInfo.id?UserInfo.id:"";
      
      store.commit('set_openid',openid);
      store.commit('set_nickname',nickname);
      store.commit('set_userid',userId);

      if(UserInfo.sfky == 'Y')
      {
        var phone = UserInfo.phone?UserInfo.phone:"";
        var name = UserInfo.name?UserInfo.name:"";
        store.commit('set_mobile',phone);
        store.commit('set_username',name);
      }

      suc_func = suc_func ? suc_func : function() {};
      suc_func();
    }
  }).catch(function() {
    //
  });
}

function getBindVehicleState(openid)
{
  api.getBindVehicleState(openid).then(function(resData) {
    var res = JSON.parse(resData);
    if (res.respCode == 0) {
      var vehicleState = res.data.yhzt;
      var yhcgbazt = res.data.yhcgbazt;
      var yhctbazt = res.data.yhctbazt;
      var yhjsybazt = res.data.yhjsybazt;
      var yhyyybazt = res.data.yhyyybazt;
      store.commit('set_vehicleState',vehicleState);
      store.commit('set_yhcgbazt',yhcgbazt);
      store.commit('set_yhctbazt',yhctbazt);
      store.commit('set_yhjsybazt',yhjsybazt);
      store.commit('set_yhyyybazt',yhyyybazt);
      var slot = 0;
      // 0=未绑定 1=未提交 2=待审核 3=审核成功；非 3 都需要处理
      if (yhcgbazt !== '3') slot++;
      if (yhctbazt !== '3') slot++;
      if (yhjsybazt !== '3') slot++;
      if (yhyyybazt !== '3') slot++;
      store.commit('set_slot',slot);
    }
  }).catch(function() {
    //
  });
}

// 检查用户是否有手机号
function checkUserHasPhone() {
  const mobile = store.state.wx_info.mobile;
  return mobile && mobile.length > 0;
}

export {
  //syncToken,
  goLogin,
  //getToken,
  //setToken,
  getUserInfo,
  getUser,
  getBindVehicleState,
  checkUserHasPhone
}
